import { Injectable } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(public eventName: string = 'i4b_events') {}

  log(category: string, label: string, value?: string) {
    gtag('event', this.eventName, {
      event_category: category,
      event_label: label,
      value,
      non_interaction: true
    });
  }

  logError(category: string, label: string, value?: string) {
    gtag('event', this.eventName, {
      event_category: category,
      event_label: label,
      value,
      non_interaction: true
    });
  }
}
